<!-- src\components\dispositivos\ModalDetalleDispositivo.vue -->
<template>
  <div v-if="visible" class="fixed inset-0 z-70 overflow-y-auto">
    <div class="fixed inset-0 bg-black bg-opacity-50 transition-opacity" @click="cerrarModal"></div>
    <div class="flex min-h-full items-center justify-center">
      <div class="relative bg-efintelwhite-50 w-full h-screen overflow-y-auto">
        <!-- BARRA SUPERIOR DE NAVEGACION ENTRE DISPOSITIVOS -->
        <div class="bg-gray-50 px-6 py-2">
          <div class="flex items-center justify-between">
            <div class="flex items-center space-x-4">
              <button @click="manejarVerAnterior" :disabled="!hayEquipoAnterior || cargandoNavegacion" :class="[
                'flex items-center space-x-2 transition-colors',
                hayEquipoAnterior && !cargandoNavegacion
                  ? 'text-gray-600 hover:text-gray-800'
                  : 'text-gray-300 cursor-not-allowed'
              ]">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                </svg>
                <span class="text-sm">Ver Anterior</span>
              </button>
            </div>
            <div>
              <span class="text-xs sm:text-base font-medium text-gray-600">LOCAL N° {{ localCompleto?.numero_local ||
                dispositivo.local_id || 'N/A' }}</span>
            </div>
            <div class="flex items-center space-x-4">
              <button @click="manejarVerSiguiente" :disabled="!hayEquipoSiguiente || cargandoNavegacion" :class="[
                'flex items-center space-x-2 transition-colors',
                hayEquipoSiguiente && !cargandoNavegacion
                  ? 'text-gray-600 hover:text-gray-800'
                  : 'text-gray-300 cursor-not-allowed'
              ]">
                <span class="text-sm">Ver Próximo</span>
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </button>
              <button @click="cerrarModal" class="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="p-2">
          <div class="grid grid-cols-1 lg:grid-cols-4 gap-3 items-stretch">
            <!-- Panel de información del dispositivo -->
            <div class="lg:col-span-1">
              <div class="bg-white rounded-lg border border-gray-200 p-5 h-full">
                <!-- Título con edición -->
                <div class="mb-5">
                  <div v-if="!editandoNombre" class="flex items-center justify-between group">
                    <h3 class="text-xl font-semibold text-gray-900 truncate">
                      {{ dispositivo.nombre_dispositivo || dispositivo.nombre }}
                    </h3>
                    <button v-if="puedeEditarDispositivo" @click="iniciarEdicionNombre" class="opacity-0 group-hover:opacity-100 transition-opacity p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg" title="Editar nombre">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                  </div>
                  <!-- Modo edición nombre -->
                  <div v-if="editandoNombre" class="space-y-2">
                    <input v-model="nombreTemporal" type="text" :disabled="guardandoNombre" @keydown.enter="guardarNombre" @keydown.escape="cancelarEdicionNombre" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg font-semibold" placeholder="Nombre del dispositivo" maxlength="100" />
                    <p class="text-xs text-gray-500">
                      Enter para guardar · Escape para cancelar
                    </p>
                  </div>
                </div>

                <!-- Imagen con edición -->
                <div class="relative group mb-6">
                  <img :src="getImagenDispositivo()" :alt="dispositivo.nombre_dispositivo || dispositivo.nombre" @error="handleImageError" class="w-full h-36 object-contain rounded-lg bg-gray-50 p-3 border border-gray-200" />
                  <button v-if="puedeEditarDispositivo" @click="iniciarEdicionImagen" class="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity p-2 bg-white rounded-lg shadow-md text-gray-400 hover:text-blue-600 hover:bg-blue-50" title="Cambiar imagen">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                  </button>
                  <input ref="inputImagen" type="file" accept="image/jpeg,image/jpg,image/png,image/gif" @change="manejarSeleccionImagen" class="hidden" />
                </div>

                <!-- Indicadores de estado (compactos) -->
                <div class="grid grid-cols-2 gap-3 mb-6">
                  <!-- Estado -->
                  <div class="bg-gray-50 rounded-lg p-3">
                    <div class="text-xs font-medium text-gray-500 mb-1">ESTADO</div>
                    <div class="flex items-center gap-2">
                      <span class="w-2 h-2 rounded-full" :class="displayEstado ? 'bg-green-500' : 'bg-gray-400'"></span>
                      <span class="text-sm font-medium" :class="displayEstado ? 'text-green-700' : 'text-gray-600'">
                        {{ displayEstado ? 'Activo' : 'Inactivo' }}
                      </span>
                    </div>
                  </div>
                  <!-- Condición -->
                  <div class="bg-gray-50 rounded-lg p-3">
                    <div class="text-xs font-medium text-gray-500 mb-1">CONDICIÓN</div>
                    <div class="flex items-center gap-2">
                      <span class="w-2 h-2 rounded-full" :class="{
                        'bg-green-500': displayCondicion === 'ONLINE',
                        'bg-gray-400': displayCondicion === 'OFFLINE',
                        'bg-red-500': displayCondicion === 'FALLA'
                      }"></span>
                      <span class="text-sm font-medium text-gray-700">{{ displayCondicion }}</span>
                    </div>
                  </div>
                  <!-- Ocupado -->
                  <div class="bg-gray-50 rounded-lg p-3">
                    <div class="text-xs font-medium text-gray-500 mb-1">OCUPADO</div>
                    <div class="flex items-center gap-2">
                      <span class="w-2 h-2 rounded-full" :class="displayOcupado ? 'bg-blue-500' : 'bg-gray-400'"></span>
                      <span class="text-sm font-medium" :class="displayOcupado ? 'text-blue-700' : 'text-gray-600'">
                        {{ displayOcupado ? 'Sí' : 'No' }}
                      </span>
                    </div>
                  </div>
                  <!-- Deshielo -->
                  <div class="bg-gray-50 rounded-lg p-3">
                    <div class="text-xs font-medium text-gray-500 mb-1">DESHIELO</div>
                    <div class="flex items-center gap-2">
                      <span class="w-2 h-2 rounded-full" :class="displayDeshielo ? 'bg-cyan-500' : 'bg-gray-400'"></span>
                      <span class="text-sm font-medium" :class="displayDeshielo ? 'text-cyan-700' : 'text-gray-600'">
                        {{ displayDeshielo ? 'Activo' : 'Inactivo' }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Atributos del dispositivo (editables inline) -->
                <div class="space-y-3">
                  <!-- LUGAR -->
                  <div class="flex items-center justify-between group py-1 border-b border-gray-100 last:border-0">
                    <span class="text-xs font-medium text-gray-500 uppercase tracking-wider">Lugar</span>
                    <div class="relative flex items-center gap-2">
                      <span v-if="!editandoUbicacion" class="text-sm text-gray-900">
                        {{ dispositivo.ubicacion_dispositivo || dispositivo.ubicacion || 'N/A' }}
                      </span>
                      <input v-else v-model="ubicacionTemporal" type="text" :disabled="guardandoUbicacion" @keydown.enter="guardarUbicacion" @keydown.escape="cancelarEdicionUbicacion" class="w-40 text-sm px-2 py-0.5 border border-gray-300 rounded focus:ring-1 focus:ring-blue-500" placeholder="Lugar" maxlength="150" />
                      <button v-if="puedeEditarDispositivo && !editandoUbicacion" @click="iniciarEdicionUbicacion" class="opacity-0 group-hover:opacity-100 transition-opacity p-1 text-gray-400 hover:text-blue-600 rounded" title="Editar lugar">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- FECHA INSTALACIÓN -->
                  <div class="flex items-center justify-between group py-1 border-b border-gray-100">
                    <span class="text-xs font-medium text-gray-500 uppercase tracking-wider">Instalación</span>
                    <div class="relative flex items-center gap-2">
                      <span v-if="!editandoFechaInstalacion" class="text-sm text-gray-900">
                        {{ formatearFecha(dispositivo.fecha_instalacion) || 'N/A' }}
                      </span>
                      <input v-else v-model="fechaInstalacionTemporal" type="date" :disabled="guardandoFechaInstalacion" @keydown.enter="guardarFechaInstalacion" @keydown.escape="cancelarEdicionFechaInstalacion" class="w-40 text-sm px-2 py-0.5 border border-gray-300 rounded focus:ring-1 focus:ring-blue-500" />
                      <button v-if="puedeEditarDispositivo && !editandoFechaInstalacion" @click="iniciarEdicionFechaInstalacion" class="opacity-0 group-hover:opacity-100 transition-opacity p-1 text-gray-400 hover:text-blue-600 rounded" title="Editar fecha">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- MODELO -->
                  <div class="flex items-center justify-between group py-1 border-b border-gray-100">
                    <span class="text-xs font-medium text-gray-500 uppercase tracking-wider">Modelo</span>
                    <div class="relative flex items-center gap-2">
                      <span v-if="!editandoModelo" class="text-sm text-gray-900">
                        {{ dispositivo.modelo_dispositivo || dispositivo.modelo || 'N/A' }}
                      </span>
                      <input v-else v-model="modeloTemporal" type="text" :disabled="guardandoModelo" @keydown.enter="guardarModelo" @keydown.escape="cancelarEdicionModelo" class="w-40 text-sm px-2 py-0.5 border border-gray-300 rounded focus:ring-1 focus:ring-blue-500" placeholder="Modelo" maxlength="100" />
                      <button v-if="puedeEditarDispositivo && !editandoModelo" @click="iniciarEdicionModelo" class="opacity-0 group-hover:opacity-100 transition-opacity p-1 text-gray-400 hover:text-blue-600 rounded" title="Editar modelo">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- MARCA -->
                  <div class="flex items-center justify-between group py-1 border-b border-gray-100">
                    <span class="text-xs font-medium text-gray-500 uppercase tracking-wider">Marca</span>
                    <div class="relative flex items-center gap-2">
                      <span v-if="!editandoMarca" class="text-sm text-gray-900">
                        {{ dispositivo.marca_dispositivo || 'No especificado' }}
                      </span>
                      <input v-else v-model="marcaTemporal" type="text" :disabled="guardandoMarca" @keydown.enter="guardarMarca" @keydown.escape="cancelarEdicionMarca" class="w-40 text-sm px-2 py-0.5 border border-gray-300 rounded focus:ring-1 focus:ring-blue-500" placeholder="Marca" maxlength="100" />
                      <button v-if="puedeEditarDispositivo && !editandoMarca" @click="iniciarEdicionMarca" class="opacity-0 group-hover:opacity-100 transition-opacity p-1 text-gray-400 hover:text-blue-600 rounded" title="Editar marca">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- CAPACIDAD FRÍO -->
                  <div class="flex items-center justify-between group py-1 border-b border-gray-100">
                    <span class="text-xs font-medium text-gray-500 uppercase tracking-wider">Cap. Frío</span>
                    <div class="relative flex items-center gap-2">
                      <span v-if="!editandoCapacidadFrio" class="text-sm text-gray-900">
                        {{ dispositivo.capacidad_frio || 'No especificado' }}
                      </span>
                      <input v-else v-model="capacidadFrioTemporal" type="text" :disabled="guardandoCapacidadFrio" @keydown.enter="guardarCapacidadFrio" @keydown.escape="cancelarEdicionCapacidadFrio" class="w-40 text-sm px-2 py-0.5 border border-gray-300 rounded focus:ring-1 focus:ring-blue-500" placeholder="Ej: 5000 BTU/h" maxlength="50" />
                      <button v-if="puedeEditarDispositivo && !editandoCapacidadFrio" @click="iniciarEdicionCapacidadFrio" class="opacity-0 group-hover:opacity-100 transition-opacity p-1 text-gray-400 hover:text-blue-600 rounded" title="Editar capacidad frío">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- CAPACIDAD CALOR -->
                  <div class="flex items-center justify-between group py-1 border-b border-gray-100">
                    <span class="text-xs font-medium text-gray-500 uppercase tracking-wider">Cap. Calor</span>
                    <div class="relative flex items-center gap-2">
                      <span v-if="!editandoCapacidadCalor" class="text-sm text-gray-900">
                        {{ dispositivo.capacidad_calor || 'No especificado' }}
                      </span>
                      <input v-else v-model="capacidadCalorTemporal" type="text" :disabled="guardandoCapacidadCalor" @keydown.enter="guardarCapacidadCalor" @keydown.escape="cancelarEdicionCapacidadCalor" class="w-40 text-sm px-2 py-0.5 border border-gray-300 rounded focus:ring-1 focus:ring-blue-500" placeholder="Ej: 4500 BTU/h" maxlength="50" />
                      <button v-if="puedeEditarDispositivo && !editandoCapacidadCalor" @click="iniciarEdicionCapacidadCalor" class="opacity-0 group-hover:opacity-100 transition-opacity p-1 text-gray-400 hover:text-blue-600 rounded" title="Editar capacidad calor">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- REFRIGERANTE -->
                  <div class="flex items-center justify-between group py-1 border-b border-gray-100">
                    <span class="text-xs font-medium text-gray-500 uppercase tracking-wider">Refrigerante</span>
                    <div class="relative flex items-center gap-2">
                      <span v-if="!editandoRefrigerante" class="text-sm text-gray-900">
                        {{ dispositivo.refrigerante || 'No especificado' }}
                      </span>
                      <input v-else v-model="refrigeranteTemporal" type="text" :disabled="guardandoRefrigerante" @keydown.enter="guardarRefrigerante" @keydown.escape="cancelarEdicionRefrigerante" class="w-40 text-sm px-2 py-0.5 border border-gray-300 rounded focus:ring-1 focus:ring-blue-500" placeholder="Ej: R410A" maxlength="50" />
                      <button v-if="puedeEditarDispositivo && !editandoRefrigerante" @click="iniciarEdicionRefrigerante" class="opacity-0 group-hover:opacity-100 transition-opacity p-1 text-gray-400 hover:text-blue-600 rounded" title="Editar refrigerante">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- CARGA -->
                  <div class="flex items-center justify-between group py-1 border-b border-gray-100">
                    <span class="text-xs font-medium text-gray-500 uppercase tracking-wider">Carga</span>
                    <div class="relative flex items-center gap-2">
                      <span v-if="!editandoCarga" class="text-sm text-gray-900">
                        {{ dispositivo.carga || 'No especificado' }}
                      </span>
                      <input v-else v-model="cargaTemporal" type="text" :disabled="guardandoCarga" @keydown.enter="guardarCarga" @keydown.escape="cancelarEdicionCarga" class="w-40 text-sm px-2 py-0.5 border border-gray-300 rounded focus:ring-1 focus:ring-blue-500" placeholder="Ej: 2.5 kg" maxlength="50" />
                      <button v-if="puedeEditarDispositivo && !editandoCarga" @click="iniciarEdicionCarga" class="opacity-0 group-hover:opacity-100 transition-opacity p-1 text-gray-400 hover:text-blue-600 rounded" title="Editar carga">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- VOLTAJE -->
                  <div class="flex items-center justify-between group py-1 border-b border-gray-100">
                    <span class="text-xs font-medium text-gray-500 uppercase tracking-wider">Voltaje</span>
                    <div class="relative flex items-center gap-2">
                      <span v-if="!editandoVoltaje" class="text-sm text-gray-900">
                        {{ dispositivo.voltaje || 'No especificado' }}
                      </span>
                      <input v-else v-model="voltajeTemporal" type="text" :disabled="guardandoVoltaje" @keydown.enter="guardarVoltaje" @keydown.escape="cancelarEdicionVoltaje" class="w-40 text-sm px-2 py-0.5 border border-gray-300 rounded focus:ring-1 focus:ring-blue-500" placeholder="Ej: 220V" maxlength="50" />
                      <button v-if="puedeEditarDispositivo && !editandoVoltaje" @click="iniciarEdicionVoltaje" class="opacity-0 group-hover:opacity-100 transition-opacity p-1 text-gray-400 hover:text-blue-600 rounded" title="Editar voltaje">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- CORRIENTE -->
                  <div class="flex items-center justify-between group py-1 border-b border-gray-100">
                    <span class="text-xs font-medium text-gray-500 uppercase tracking-wider">Corriente</span>
                    <div class="relative flex items-center gap-2">
                      <span v-if="!editandoCorriente" class="text-sm text-gray-900">
                        {{ dispositivo.corriente || 'No especificado' }}
                      </span>
                      <input v-else v-model="corrienteTemporal" type="text" :disabled="guardandoCorriente" @keydown.enter="guardarCorriente" @keydown.escape="cancelarEdicionCorriente" class="w-40 text-sm px-2 py-0.5 border border-gray-300 rounded focus:ring-1 focus:ring-blue-500" placeholder="Ej: 15A" maxlength="50" />
                      <button v-if="puedeEditarDispositivo && !editandoCorriente" @click="iniciarEdicionCorriente" class="opacity-0 group-hover:opacity-100 transition-opacity p-1 text-gray-400 hover:text-blue-600 rounded" title="Editar corriente">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Panel de rendimiento -->
            <div class="lg:col-span-2">
              <div class="bg-white rounded-lg border border-gray-200 p-5 h-full">
                <!-- Header con título y botón documentos -->
                <div class="flex items-center justify-between mb-5">
                  <h3 class="text-lg font-semibold text-gray-900">Rendimiento</h3>
                  <button @click="abrirGestorArchivos" class="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all" title="Gestor de archivos">
                    <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                    </svg>
                    <span>Documentos</span>
                  </button>
                </div>

                <!-- Tarjetas de métricas (grid 4 columnas) -->
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                  <!-- T° Inyección -->
                  <div class="bg-gray-50 rounded-lg p-4 text-center border border-gray-100">
                    <div class="text-2xl font-bold text-gray-900 mb-1">
                      {{ Math.round(displayTempInyeccion * 10) / 10 }}°C
                    </div>
                    <div class="text-xs text-gray-500 flex items-center justify-center gap-1">
                      <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                      T° Inyección
                    </div>
                    <!-- Mini barra de progreso (rango 0-50°C como ejemplo) -->
                    <div class="mt-2 h-1 w-full bg-gray-200 rounded-full overflow-hidden">
                      <div class="h-full rounded-full" :class="{
                        'bg-blue-500': displayModo === 'FRIO',
                        'bg-orange-500': displayModo === 'CALOR',
                        'bg-green-500': displayModo === 'VENTILACION',
                        'bg-gray-400': displayModo === 'OFF' || !displayModo
                      }" :style="{ width: `${Math.min((displayTempInyeccion / 50) * 100, 100)}%` }"></div>
                    </div>
                  </div>

                  <!-- T° Retorno -->
                  <div class="bg-gray-50 rounded-lg p-4 text-center border border-gray-100">
                    <div class="text-2xl font-bold text-gray-900 mb-1">
                      {{ Math.round(displayTempRetorno * 10) / 10 }}°C
                    </div>
                    <div class="text-xs text-gray-500 flex items-center justify-center gap-1">
                      <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                      T° Retorno
                    </div>
                    <div class="mt-2 h-1 w-full bg-gray-200 rounded-full overflow-hidden">
                      <div class="h-full bg-blue-500 rounded-full" :style="{ width: `${Math.min((displayTempRetorno / 50) * 100, 100)}%` }"></div>
                    </div>
                  </div>

                  <!-- Modo -->
                  <div class="bg-gray-50 rounded-lg p-4 text-center border border-gray-100">
                    <div class="flex items-center justify-center gap-2 mb-1">
                      <!-- Ícono FRIO -->
                      <svg v-if="displayModo === 'FRIO'" class="w-6 h-6 text-blue-500" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2l-1 1v3l-3-3-1.5 1.5 3 3H6l-1 1 1 1h3.5l-3 3L8 14l3-3v3.5l1 1 1-1V11l3 3 1.5-1.5-3-3H18l1-1-1-1h-3.5l3-3L16 4l-3 3V3.5z" />
                      </svg>
                      <!-- Ícono CALOR -->
                      <svg v-else-if="displayModo === 'CALOR'" class="w-6 h-6 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
                      </svg>
                      <!-- Ícono VENTILACION -->
                      <svg v-else-if="displayModo === 'VENTILACION'" class="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                      </svg>
                      <!-- Ícono OFF / Desconocido -->
                      <svg v-else class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z" clip-rule="evenodd" />
                      </svg>
                      <span class="text-sm font-medium" :class="{
                        'text-blue-600': displayModo === 'FRIO',
                        'text-orange-600': displayModo === 'CALOR',
                        'text-green-600': displayModo === 'VENTILACION',
                        'text-gray-500': displayModo !== 'FRIO' && displayModo !== 'CALOR' && displayModo !== 'VENTILACION'
                      }">
                        {{ displayModo === 'VENTILACION' ? 'Ventilación' : (displayModo ? displayModo.charAt(0) + displayModo.slice(1).toLowerCase() : 'Off') }}
                      </span>
                    </div>
                    <div class="text-xs text-gray-500">Modo</div>
                  </div>

                  <!-- T° Exterior -->
                  <div class="bg-gray-50 rounded-lg p-4 text-center border border-gray-100">
                    <div class="text-2xl font-bold text-gray-900 mb-1">
                      {{ Math.round(displayTempExterior * 10) / 10 }}°C
                    </div>
                    <div class="text-xs text-gray-500 flex items-center justify-center gap-1">
                      <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                      T° Exterior
                    </div>
                    <div class="mt-2 h-1 w-full bg-gray-200 rounded-full overflow-hidden">
                      <div class="h-full rounded-full" :class="{
                        'bg-red-500': displayTempExterior >= 25,
                        'bg-yellow-500': displayTempExterior >= 15 && displayTempExterior < 25,
                        'bg-blue-400': displayTempExterior >= 5 && displayTempExterior < 15,
                        'bg-blue-600': displayTempExterior < 5
                      }" :style="{ width: `${Math.min((displayTempExterior / 40) * 100, 100)}%` }"></div>
                    </div>
                  </div>
                </div>

                <!-- GRÁFICO HISTÓRICO -->
                <slot name="grafico-historial" :ref-grafico="$refs.graficoHistorial"></slot>
              </div>
            </div>
            <!-- Panel de operación y alertas -->
            <div class="lg:col-span-1">
              <div class="bg-white rounded-lg border border-efintelwhite-55 overflow-hidden h-full flex flex-col">
                <!-- Header colapsable de Operación -->
                <button @click="mostrarOperacion = !mostrarOperacion" class="w-full flex items-center justify-between px-4 py-3 text-lg font-semibold hover:bg-gray-50 transition-colors border-b border-gray-200">
                  <span class="text-gray-900">Operación</span>
                  <svg :class="{ 'rotate-180': mostrarOperacion }" class="w-5 h-5 text-gray-400 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                <!-- Contenido de Operación (colapsable) -->
                <div v-show="mostrarOperacion" class="p-4">
                  <div class="mb-6">
                    <div class="flex items-center justify-between mb-2">
                      <span class="text-sm font-medium text-gray-700">Encendido</span>
                      <div class="flex items-center">
                        <span class="text-xs text-gray-500 mr-2">OFF</span>
                        <div class="relative">
                          <input type="checkbox" v-model="estadoPower" @change="togglePower" :disabled="!estaEnLinea" class="sr-only">
                          <div :class="[
                            'w-10 h-6 rounded-full shadow-inner cursor-pointer transition-colors',
                            estadoPower ? 'bg-green-500' : 'bg-gray-300',
                            !estaEnLinea ? 'opacity-50 cursor-not-allowed' : ''
                          ]" @click="togglePower">
                            <div :class="[
                              'w-4 h-4 bg-white rounded-full shadow transform translate-y-1 transition-transform duration-200',
                              estadoPower ? 'translate-x-5' : 'translate-x-1'
                            ]"></div>
                          </div>
                        </div>
                        <span class="text-xs text-gray-500 ml-2">ON</span>
                      </div>
                    </div>
                  </div>

                  <div class="bg-green-100 rounded-lg p-4 mb-4">
                    <div class="text-center">
                      <div class="text-2xl font-bold text-green-700 mb-1">
                        {{ displayTempObjetivo }}°C
                      </div>
                      <p class="text-sm text-green-600">Temperatura Objetivo</p>
                      <div class="flex items-center justify-center space-x-2 mt-3">
                        <button @click="decrementTemp" :disabled="!estaEnLinea" class="w-8 h-8 bg-green-200 rounded-full flex items-center justify-center hover:bg-green-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                          <svg class="w-4 h-4 text-green-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"></path>
                          </svg>
                        </button>
                        <button @click="incrementTemp" :disabled="!estaEnLinea" class="w-8 h-8 bg-green-200 rounded-full flex items-center justify-center hover:bg-green-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                          <svg class="w-4 h-4 text-green-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700 mb-2">Modo</label>
                    <div class="flex items-center gap-3">
                      <select v-model="modoDispositivoComputado" :disabled="!estaEnLinea" class="flex-1 px-3 py-2 border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-sm disabled:bg-gray-100 disabled:text-gray-500">
                        <option value="OFF">OFF</option>
                        <option value="FRIO">Frío</option>
                        <option value="CALOR">Calor</option>
                        <option value="VENTILACION">Ventilación</option>
                      </select>

                      <div class="flex-shrink-0">
                        <!-- Ícono OFF -->
                        <svg v-if="displayModo === 'OFF'" class="w-10 h-10 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z" clip-rule="evenodd" />
                        </svg>

                        <!-- Ícono FRIO -->
                        <svg v-else-if="displayModo === 'FRIO'" class="w-10 h-10 text-blue-500" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2l-1 1v3l-3-3-1.5 1.5 3 3H6l-1 1 1 1h3.5l-3 3L8 14l3-3v3.5l1 1 1-1V11l3 3 1.5-1.5-3-3H18l1-1-1-1h-3.5l3-3L16 4l-3 3V3.5z" />
                        </svg>

                        <!-- Ícono CALOR -->
                        <svg v-else-if="displayModo === 'CALOR'" class="w-10 h-10 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
                        </svg>

                        <!-- Ícono VENTILACION -->
                        <svg v-else-if="displayModo === 'VENTILACION'" class="w-10 h-10 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                        </svg>

                        <!-- Ícono por defecto -->
                        <svg v-else class="w-10 h-10 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                        </svg>
                      </div>
                    </div>

                    <!-- Indicador de deshielo -->
                    <div v-if="displayDeshielo && estaEnLinea" class="mt-2 px-2 py-1 bg-cyan-50 border border-cyan-200 rounded text-xs text-cyan-700">
                      🧊 Modo Deshielo Activo
                    </div>

                    <!-- Indicador offline -->
                    <div v-if="!estaEnLinea" class="mt-2 px-2 py-1 bg-gray-50 border border-gray-200 rounded text-xs text-gray-500">
                      📡 Dispositivo Offline - Datos no actualizados
                    </div>
                  </div>

                  <div class="flex flex-col gap-2">
                    <button @click="$emit('abrir-modal-horario')" class="w-full bg-blue-600 text-white py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors">
                      Ir a Horario
                    </button>
                  </div>
                </div>

                <!-- Separador (solo visible cuando operación está expandida) -->
                <div v-if="mostrarOperacion" class="border-t border-gray-200"></div>

                <!-- Sección de Alertas y Botones a exportar (siempre visible) -->
                <div class="flex-grow flex flex-col p-4">
                  <div class="mb-4 space-y-1.5">
                    <!-- PDF -->
                    <button @click="handleExportarPDF" class="w-full flex items-center gap-2 px-3 py-1.5 bg-white border border-red-500 rounded-lg text-sm font-medium text-gray-700 transition-all hover:border-red-600 hover:bg-red-50 hover:shadow-md">
                      <svg class="w-3.5 h-3.5 text-red-500 transition-colors group-hover:text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                      </svg>
                      Reporte Técnico PDF
                    </button>
                    <!-- Excel -->
                    <button @click="handleExportarExcel" class="w-full flex items-center gap-2 px-3 py-1.5 bg-white border border-emerald-500 rounded-lg text-sm font-medium text-gray-700 transition-all hover:border-emerald-600 hover:bg-emerald-50 hover:shadow-md">
                      <svg class="w-3.5 h-3.5 text-emerald-600 transition-colors group-hover:text-emerald-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      Reporte Técnico Excel
                    </button>
                    <!-- PNG -->
                    <button @click="exportarGraficoImagen" class="w-full flex items-center gap-2 px-3 py-1.5 bg-white border border-purple-500 rounded-lg text-sm font-medium text-gray-700 transition-all hover:border-purple-600 hover:bg-purple-50 hover:shadow-md">
                      <svg class="w-3.5 h-3.5 text-purple-600 transition-colors group-hover:text-purple-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      Gráfico PNG
                    </button>
                  </div>

                  <div class="flex-grow flex flex-col">
                    <slot name="alertas-dispositivo"></slot>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="mostrarGestorArchivos" class="fixed inset-0 z-80 overflow-y-auto">
      <div class="fixed inset-0 bg-black bg-opacity-50" @click="cerrarGestorArchivos"></div>
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative bg-white rounded-lg max-w-5xl w-full max-h-[90vh] overflow-y-auto">
          <button @click="cerrarGestorArchivos" class="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center z-10">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>

          <ModalGestorArchivo :dispositivo-id="dispositivo.id" :breadcrumb-parent="localCompleto?.nombre_local || 'Local'" :breadcrumb-current="dispositivo.nombre_dispositivo || dispositivo.nombre" titulo="Gestor de Archivos" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DispositivosService from '@/services/dispositivos/dispositivos.js'
import PermissionsService from '@/services/auth/permissions.js'
import ModalGestorArchivo from './ModalGestorArchivo.vue'
import { exportarDispositivoPDF } from '@/services/dispositivos/exportPdfDispositivo.js'
import { sensorMap, getNumber } from '@/services/utils/sensores.js'

export default {
  name: 'ModalDetalleDispositivo',
  components: {
    ModalGestorArchivo
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dispositivo: {
      type: Object,
      required: true
    },
    hayEquipoAnterior: {
      type: Boolean,
      default: false
    },
    hayEquipoSiguiente: {
      type: Boolean,
      default: false
    },
    cargandoNavegacion: {
      type: Boolean,
      default: false
    },
    localCompleto: {
      type: Object,
      default: null
    }
  },
  emits: [
    'cerrar',
    'ver-equipo-anterior',
    'ver-equipo-siguiente',
    'abrir-modal-horario',
    'exportar-pdf',
    'abrir-gestor-archivos',
    'cambiar-modo',
    'mostrar-error',
    'imagen-actualizada',
    'imagen-eliminada',
    'edicion-nombre-iniciada',
    'campo-guardado',
    'nombre-guardado',
    'ubicacion-guardada',
    'toggle-power',
    'incrementar-temp',
    'decrementar-temp'
  ],
  data() {
    return {
      editandoNombre: false,
      nombreTemporal: '',
      guardandoNombre: false,
      editandoUbicacion: false,
      ubicacionTemporal: '',
      guardandoUbicacion: false,
      editandoFechaInstalacion: false,
      fechaInstalacionTemporal: '',
      guardandoFechaInstalacion: false,
      editandoModelo: false,
      modeloTemporal: '',
      guardandoModelo: false,
      editandoMarca: false,
      marcaTemporal: '',
      guardandoMarca: false,
      editandoCapacidadFrio: false,
      capacidadFrioTemporal: '',
      guardandoCapacidadFrio: false,
      editandoCapacidadCalor: false,
      capacidadCalorTemporal: '',
      guardandoCapacidadCalor: false,
      editandoRefrigerante: false,
      refrigeranteTemporal: '',
      guardandoRefrigerante: false,
      editandoCarga: false,
      cargaTemporal: '',
      guardandoCarga: false,
      editandoVoltaje: false,
      voltajeTemporal: '',
      guardandoVoltaje: false,
      editandoCorriente: false,
      corrienteTemporal: '',
      guardandoCorriente: false,
      estadoPower: false,
      modoDispositivo: 'OFF',
      imageError: false,
      archivoImagenSeleccionado: null,
      previsualizacionImagen: null,
      subiendoImagen: false,
      mostrarGestorArchivos: false,
      mostrarOperacion: false,
    }
  },

  computed: {
    puedeEditarDispositivo() {
      return PermissionsService.can('dispositivos', 'editar')
    },

    // Estado en línea - verificación estricta
    estaEnLinea() {
      return this.dispositivo?.en_linea === true;
    },

    // Valores de Rendimiento
    displayTempInyeccion() {
      const s = sensorMap(this.dispositivo);
      // Quitamos la condición this.estaEnLinea para no forzar el 0 
      return getNumber(s, "Temp Inyeccion", null) ?? this.dispositivo.potenciaActiva ?? 0;
    },
    displayTempRetorno() {
      const s = sensorMap(this.dispositivo);
      return getNumber(s, "Temp Retorno", null) ?? this.dispositivo.tempRetorno ?? 0;
    },
    displayTempExterior() {
      const s = sensorMap(this.dispositivo);
      return getNumber(s, "Temp Exterior", null) ?? this.dispositivo.tempExterior ?? 0;
    },
    displayTempObjetivo() {
      const s = sensorMap(this.dispositivo);
      return getNumber(s, "Setpoint", null) ?? this.dispositivo.tempObjetivo ?? 22;
    },

    // Valores de Información
    displayEstado() {
      return this.estaEnLinea ? (this.dispositivo.encendido || this.dispositivo.activo_dispositivo) : false;
    },

    displayCondicion() {
      if (!this.estaEnLinea) return 'OFFLINE';

      const s = sensorMap(this.dispositivo);
      const configuracion = this.dispositivo.configuracion_dispositivo || {};

      const modoError = (
        s['Modo'] === 'ERROR' || // Buscamos primero en los nuevos sensores
        this.dispositivo.modo_obtencion === 'ERROR' ||
        this.dispositivo.modo === 'ERROR' ||
        configuracion.Modo === 'ERROR' ||
        configuracion.error === true
      );

      return modoError ? 'FALLA' : 'OPERATIVO';
    },

    displayOcupado() {
      if (!this.estaEnLinea) return false;
      const s = sensorMap(this.dispositivo);

      // Verificamos el sensor primero evaluándolo como texto o booleano
      if (s['Occupied'] !== undefined) {
        return String(s['Occupied']).toLowerCase() === 'true';
      }

      // Fallback a configuración antigua
      return this.dispositivo.configuracion_dispositivo?.['Occupied'] || false;
    },

    // Estado de deshielo
    displayDeshielo() {
      if (!this.estaEnLinea) return false;
      const s = sensorMap(this.dispositivo);

      // Verificamos las posibles escrituras del sensor primero
      const deshieloSensor = s['Deshielo'] ?? s['deshielo'] ?? s['DESHIELO'];
      if (deshieloSensor !== undefined) {
        return String(deshieloSensor).toLowerCase() === 'true';
      }

      // Fallback a configuración antigua
      const configuracion = this.dispositivo.configuracion_dispositivo || {};
      return Boolean(
        configuracion.Deshielo ||
        configuracion.deshielo ||
        configuracion.DESHIELO ||
        this.dispositivo.deshielo_activo ||
        false
      );
    },

    // Modo de operación con mapeo consistente
    displayModo() {
      if (!this.estaEnLinea) return 'OFF';
      const s = sensorMap(this.dispositivo);

      // Priorizamos el sensor "Modo", con fallback a los atributos antiguos
      let modo = s['Modo'] ?? this.dispositivo.modo_obtencion ?? this.dispositivo.modo ?? 'OFF';

      // Mapear valores numéricos si vienen del backend (soporta "1" numérico en texto)
      if (typeof modo === 'number' || !isNaN(Number(modo))) {
        const modoNum = Number(modo);
        const mapeoModos = {
          0: 'OFF',
          1: 'FRIO',
          2: 'CALOR',
          3: 'VENTILACION'
        };
        modo = mapeoModos[modoNum] || 'OFF';
      }

      // Normalizar strings para consistencia
      if (typeof modo === 'string') {
        const modoNormalizado = modo.toUpperCase();
        const mapeoStrings = {
          'OFF': 'OFF',
          'FRIO': 'FRIO',
          'FRÍO': 'FRIO',
          'CALOR': 'CALOR',
          'VENTILACION': 'VENTILACION',
          'VENTILACIÓN': 'VENTILACION',
          'AUTO': 'AUTO',
          'MANUAL': 'MANUAL'
        };
        modo = mapeoStrings[modoNormalizado] || 'OFF';
      }

      return modo;
    },

    // Computed para v-model del select
    modoDispositivoComputado: {
      get() {
        return this.displayModo;
      },
      set(nuevoModo) {
        this.modoDispositivo = nuevoModo;
        this.$emit('cambiar-modo', nuevoModo);
      }
    }
  },

  watch: {
    dispositivo: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.estadoPower = this.displayEstado;
          this.modoDispositivo = this.displayModo;
        }
      }
    },

    // Watch para cambios en el estado en línea
    estaEnLinea: {
      handler(newVal) {
        console.log(`📡 Estado en línea cambió a: ${newVal} para dispositivo ${this.dispositivo?.id}`);
        if (!newVal) {
          // Reset de controles cuando va offline
          this.editandoNombre = false;
          this.editandoUbicacion = false;
          this.editandoFechaInstalacion = false;
          this.editandoModelo = false;
          this.editandoMarca = false;
          this.editandoCapacidadFrio = false;
          this.editandoCapacidadCalor = false;
          this.editandoRefrigerante = false;
          this.editandoCarga = false;
          this.editandoVoltaje = false;
          this.editandoCorriente = false;
        }
      }
    }
  },

  mounted() {
    document.addEventListener('keydown', this.handleEscapeKey);
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEscapeKey);
  },

  methods: {
    cancelarGraficosPendientes() {
      if (this.$parent.$refs.graficoHistorial && this.$parent.$refs.graficoHistorial.cancelarPeticionSilenciosa) {
        this.$parent.$refs.graficoHistorial.cancelarPeticionSilenciosa();
      }
    },
    manejarVerAnterior() {
      this.cancelarGraficosPendientes();
      this.$emit('ver-equipo-anterior');
    },
    manejarVerSiguiente() {
      this.cancelarGraficosPendientes();
      this.$emit('ver-equipo-siguiente');
    },
    cerrarModal() {
      this.cancelarGraficosPendientes();
      this.$emit('cerrar');
    },

    exportarGraficoImagen() {
      if (this.$parent.$refs.graficoHistorial && this.$parent.$refs.graficoHistorial.exportarImagen) {
        this.$parent.$refs.graficoHistorial.exportarImagen()
      } else {
        console.warn('Componente gráfico no disponible para exportar imagen')
      }
    },

    async handleExportarPDF() {
      try {
        await exportarDispositivoPDF(this.dispositivo.id, 'pdf')
        console.log('✅ PDF exportado correctamente desde el backend')
      } catch (error) {
        console.error('❌ Error exportando PDF:', error)
        this.$emit('mostrar-error', 'Error al descargar el PDF.')
      }
    },
    async handleExportarExcel() {
      try {
        // Llamamos al backend pasando el ID y el formato 'excel'
        await exportarDispositivoPDF(this.dispositivo.id, 'excel')
        console.log('✅ Excel exportado correctamente desde el backend')
      } catch (error) {
        console.error('❌ Error exportando Excel:', error)
        this.$emit('mostrar-error', 'Error al descargar el Excel.')
      }
    },
    abrirGestorArchivos() {
      this.mostrarGestorArchivos = true
    },

    cerrarGestorArchivos() {
      this.mostrarGestorArchivos = false
    },

    handleEscapeKey(event) {
      if (event.key === 'Escape') {
        if (this.editandoNombre) {
          this.cancelarEdicionNombre();
        } else if (this.editandoUbicacion) {
          this.cancelarEdicionUbicacion();
        } else if (this.editandoFechaInstalacion) {
          this.cancelarEdicionFechaInstalacion();
        } else if (this.editandoModelo) {
          this.cancelarEdicionModelo();
        } else if (this.editandoMarca) {
          this.cancelarEdicionMarca();
        } else if (this.editandoCapacidadFrio) {
          this.cancelarEdicionCapacidadFrio();
        } else if (this.editandoCapacidadCalor) {
          this.cancelarEdicionCapacidadCalor();
        } else if (this.editandoRefrigerante) {
          this.cancelarEdicionRefrigerante();
        } else if (this.editandoCarga) {
          this.cancelarEdicionCarga();
        } else if (this.editandoVoltaje) {
          this.cancelarEdicionVoltaje();
        } else if (this.editandoCorriente) {
          this.cancelarEdicionCorriente();
        }
      }
    },

    // Utilidades y Formateo
    formatearFecha(fechaISO) {
      if (!fechaISO) return null;
      const fechaLocalISO = fechaISO.includes('T') ? fechaISO : fechaISO.replace(/-/g, '/');
      try {
        const fecha = new Date(fechaLocalISO);
        if (isNaN(fecha.getTime())) {
          return null;
        }
        return fecha.toLocaleDateString('es-CL', { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' });
      } catch (error) {
        console.error('Error formateando fecha:', error);
        return null;
      }
    },

    // Gestión de Edición Activa
    cancelarEdicionActiva() {
      if (this.editandoNombre) {
        this.cancelarEdicionNombre();
      } else if (this.editandoUbicacion) {
        this.cancelarEdicionUbicacion();
      } else if (this.editandoFechaInstalacion) {
        this.cancelarEdicionFechaInstalacion();
      } else if (this.editandoModelo) {
        this.cancelarEdicionModelo();
      } else if (this.editandoMarca) {
        this.cancelarEdicionMarca();
      } else if (this.editandoCapacidadFrio) {
        this.cancelarEdicionCapacidadFrio();
      } else if (this.editandoCapacidadCalor) {
        this.cancelarEdicionCapacidadCalor();
      } else if (this.editandoRefrigerante) {
        this.cancelarEdicionRefrigerante();
      } else if (this.editandoCarga) {
        this.cancelarEdicionCarga();
      } else if (this.editandoVoltaje) {
        this.cancelarEdicionVoltaje();
      } else if (this.editandoCorriente) {
        this.cancelarEdicionCorriente();
      }
    },

    // Edición de Nombre del Dispositivo
    iniciarEdicionNombre() {
      this.editandoNombre = true;
      this.nombreTemporal = this.dispositivo.nombre_dispositivo || this.dispositivo.nombre || '';
      this.$nextTick(() => {
        const input = document.getElementById('input-nombre-dispositivo');
        if (input) {
          input.focus();
          input.select();
        }
      });
      this.$emit('edicion-nombre-iniciada');
    },

    cancelarEdicionNombre() {
      this.editandoNombre = false;
      this.nombreTemporal = '';
      this.guardandoNombre = false;
    },

    manejarTeclasNombre(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.guardarNombre();
          break;
        case 'Escape':
          event.preventDefault();
          this.cancelarEdicionNombre();
          break;
      }
    },

    guardarNombre() {
      if (!this.nombreTemporal.trim()) {
        this.cancelarEdicionNombre();
        return;
      }
      if (this.nombreTemporal.trim() === (this.dispositivo.nombre_dispositivo || this.dispositivo.nombre)) {
        this.cancelarEdicionNombre();
        return;
      }
      this.guardandoNombre = true;
      this.$emit('nombre-guardado', this.nombreTemporal.trim());
    },

    // Edición de Ubicación del Dispositivo
    iniciarEdicionUbicacion() {
      this.editandoUbicacion = true;
      this.ubicacionTemporal = this.dispositivo.ubicacion_dispositivo || this.dispositivo.ubicacion || '';
      this.$nextTick(() => {
        const input = document.getElementById('input-ubicacion-dispositivo');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    cancelarEdicionUbicacion() {
      this.editandoUbicacion = false;
      this.ubicacionTemporal = '';
      this.guardandoUbicacion = false;
    },

    manejarTeclasUbicacion(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.guardarUbicacion();
          break;
        case 'Escape':
          event.preventDefault();
          this.cancelarEdicionUbicacion();
          break;
      }
    },

    guardarUbicacion() {
      if (!this.ubicacionTemporal.trim()) {
        this.cancelarEdicionUbicacion();
        return;
      }
      if (this.ubicacionTemporal.trim() === (this.dispositivo.ubicacion_dispositivo || this.dispositivo.ubicacion)) {
        this.cancelarEdicionUbicacion();
        return;
      }
      this.guardandoUbicacion = true;
      this.$emit('ubicacion-guardada', this.ubicacionTemporal.trim());
      this.cancelarEdicionUbicacion();
    },

    // Edición de Fecha de Instalación
    iniciarEdicionFechaInstalacion() {
      this.editandoFechaInstalacion = true;
      this.fechaInstalacionTemporal = this.dispositivo.fecha_instalacion || '';
      this.$nextTick(() => {
        const input = document.getElementById('input-fecha-instalacion-dispositivo');
        if (input) {
          input.focus();
        }
      });
    },

    cancelarEdicionFechaInstalacion() {
      this.editandoFechaInstalacion = false;
      this.fechaInstalacionTemporal = '';
      this.guardandoFechaInstalacion = false;
    },

    manejarTeclasFechaInstalacion(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.guardarFechaInstalacion();
          break;
        case 'Escape':
          event.preventDefault();
          this.cancelarEdicionFechaInstalacion();
          break;
      }
    },

    guardarFechaInstalacion() {
      if (!this.fechaInstalacionTemporal) {
        this.cancelarEdicionFechaInstalacion();
        return;
      }
      if (this.fechaInstalacionTemporal === this.dispositivo.fecha_instalacion) {
        this.cancelarEdicionFechaInstalacion();
        return;
      }
      this.guardandoFechaInstalacion = true;
      this.$emit('campo-guardado', {
        campo: 'fecha_instalacion',
        valor: this.fechaInstalacionTemporal
      });
      this.cancelarEdicionFechaInstalacion();
    },

    // Edición de Modelo del Dispositivo
    iniciarEdicionModelo() {
      this.editandoModelo = true;
      this.modeloTemporal = this.dispositivo.modelo_dispositivo || this.dispositivo.modelo || '';
      this.$nextTick(() => {
        const input = document.getElementById('input-modelo-dispositivo');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    cancelarEdicionModelo() {
      this.editandoModelo = false;
      this.modeloTemporal = '';
      this.guardandoModelo = false;
    },

    manejarTeclasModelo(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.guardarModelo();
          break;
        case 'Escape':
          event.preventDefault();
          this.cancelarEdicionModelo();
          break;
      }
    },

    guardarModelo() {
      this.guardandoModelo = true;
      this.$emit('campo-guardado', {
        campo: 'modelo_dispositivo',
        valor: this.modeloTemporal.trim()
      });
      this.cancelarEdicionModelo();
    },

    // Edición de Marca del Dispositivo
    iniciarEdicionMarca() {
      this.editandoMarca = true;
      this.marcaTemporal = this.dispositivo.marca_dispositivo || '';
      this.$nextTick(() => {
        const input = document.getElementById('input-marca-dispositivo');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    cancelarEdicionMarca() {
      this.editandoMarca = false;
      this.marcaTemporal = '';
      this.guardandoMarca = false;
    },

    manejarTeclasMarca(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.guardarMarca();
          break;
        case 'Escape':
          event.preventDefault();
          this.cancelarEdicionMarca();
          break;
      }
    },

    guardarMarca() {
      this.guardandoMarca = true;
      this.$emit('campo-guardado', {
        campo: 'marca_dispositivo',
        valor: this.marcaTemporal.trim()
      });
      this.cancelarEdicionMarca();
    },

    // Edición de Capacidad de Frío
    iniciarEdicionCapacidadFrio() {
      this.editandoCapacidadFrio = true;
      this.capacidadFrioTemporal = this.dispositivo.capacidad_frio || '';
      this.$nextTick(() => {
        const input = document.getElementById('input-capacidad-frio-dispositivo');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    cancelarEdicionCapacidadFrio() {
      this.editandoCapacidadFrio = false;
      this.capacidadFrioTemporal = '';
      this.guardandoCapacidadFrio = false;
    },

    manejarTeclasCapacidadFrio(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.guardarCapacidadFrio();
          break;
        case 'Escape':
          event.preventDefault();
          this.cancelarEdicionCapacidadFrio();
          break;
      }
    },

    guardarCapacidadFrio() {
      this.guardandoCapacidadFrio = true;
      this.$emit('campo-guardado', {
        campo: 'capacidad_frio',
        valor: this.capacidadFrioTemporal.trim()
      });
      this.cancelarEdicionCapacidadFrio();
    },

    // Edición de Capacidad de Calor
    iniciarEdicionCapacidadCalor() {
      this.editandoCapacidadCalor = true;
      this.capacidadCalorTemporal = this.dispositivo.capacidad_calor || '';
      this.$nextTick(() => {
        const input = document.getElementById('input-capacidad-calor-dispositivo');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    cancelarEdicionCapacidadCalor() {
      this.editandoCapacidadCalor = false;
      this.capacidadCalorTemporal = '';
      this.guardandoCapacidadCalor = false;
    },

    manejarTeclasCapacidadCalor(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.guardarCapacidadCalor();
          break;
        case 'Escape':
          event.preventDefault();
          this.cancelarEdicionCapacidadCalor();
          break;
      }
    },

    guardarCapacidadCalor() {
      this.guardandoCapacidadCalor = true;
      this.$emit('campo-guardado', {
        campo: 'capacidad_calor',
        valor: this.capacidadCalorTemporal.trim()
      });
      this.cancelarEdicionCapacidadCalor();
    },

    // Edición de Refrigerante
    iniciarEdicionRefrigerante() {
      this.editandoRefrigerante = true;
      this.refrigeranteTemporal = this.dispositivo.refrigerante || '';
      this.$nextTick(() => {
        const input = document.getElementById('input-refrigerante-dispositivo');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    cancelarEdicionRefrigerante() {
      this.editandoRefrigerante = false;
      this.refrigeranteTemporal = '';
      this.guardandoRefrigerante = false;
    },

    manejarTeclasRefrigerante(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.guardarRefrigerante();
          break;
        case 'Escape':
          event.preventDefault();
          this.cancelarEdicionRefrigerante();
          break;
      }
    },

    guardarRefrigerante() {
      this.guardandoRefrigerante = true;
      this.$emit('campo-guardado', {
        campo: 'refrigerante',
        valor: this.refrigeranteTemporal.trim()
      });
      this.cancelarEdicionRefrigerante();
    },

    // Edición de Carga
    iniciarEdicionCarga() {
      this.editandoCarga = true;
      this.cargaTemporal = this.dispositivo.carga || '';
      this.$nextTick(() => {
        const input = document.getElementById('input-carga-dispositivo');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    cancelarEdicionCarga() {
      this.editandoCarga = false;
      this.cargaTemporal = '';
      this.guardandoCarga = false;
    },

    manejarTeclasCarga(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.guardarCarga();
          break;
        case 'Escape':
          event.preventDefault();
          this.cancelarEdicionCarga();
          break;
      }
    },

    guardarCarga() {
      this.guardandoCarga = true;
      this.$emit('campo-guardado', {
        campo: 'carga',
        valor: this.cargaTemporal.trim()
      });
      this.cancelarEdicionCarga();
    },

    // Edición de Voltaje
    iniciarEdicionVoltaje() {
      this.editandoVoltaje = true;
      this.voltajeTemporal = this.dispositivo.voltaje || '';
      this.$nextTick(() => {
        const input = document.getElementById('input-voltaje-dispositivo');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    cancelarEdicionVoltaje() {
      this.editandoVoltaje = false;
      this.voltajeTemporal = '';
      this.guardandoVoltaje = false;
    },

    manejarTeclasVoltaje(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.guardarVoltaje();
          break;
        case 'Escape':
          event.preventDefault();
          this.cancelarEdicionVoltaje();
          break;
      }
    },

    guardarVoltaje() {
      this.guardandoVoltaje = true;
      this.$emit('campo-guardado', {
        campo: 'voltaje',
        valor: this.voltajeTemporal.trim()
      });
      this.cancelarEdicionVoltaje();
    },

    // Edición de Corriente
    iniciarEdicionCorriente() {
      this.editandoCorriente = true;
      this.corrienteTemporal = this.dispositivo.corriente || '';
      this.$nextTick(() => {
        const input = document.getElementById('input-corriente-dispositivo');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    cancelarEdicionCorriente() {
      this.editandoCorriente = false;
      this.corrienteTemporal = '';
      this.guardandoCorriente = false;
    },

    manejarTeclasCorriente(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.guardarCorriente();
          break;
        case 'Escape':
          event.preventDefault();
          this.cancelarEdicionCorriente();
          break;
      }
    },

    guardarCorriente() {
      this.guardandoCorriente = true;
      this.$emit('campo-guardado', {
        campo: 'corriente',
        valor: this.corrienteTemporal.trim()
      });
      this.cancelarEdicionCorriente();
    },

    // Control del Dispositivo con verificación online
    togglePower() {
      if (!this.estaEnLinea) {
        alert('El dispositivo está offline. No se pueden realizar cambios.');
        return;
      }
      this.$emit('toggle-power', !this.estadoPower);
    },

    incrementTemp() {
      if (!this.estaEnLinea) {
        alert('El dispositivo está offline. No se pueden realizar cambios.');
        return;
      }
      this.$emit('incrementar-temp');
    },

    decrementTemp() {
      if (!this.estaEnLinea) {
        alert('El dispositivo está offline. No se pueden realizar cambios.');
        return;
      }
      this.$emit('decrementar-temp');
    },

    // Gestión de Imágenes del Dispositivo
    getImagenDispositivo() {
      if (this.imageError) {
        return this.getImagePlaceholder()
      }
      if (this.dispositivo.media) {
        return DispositivosService.obtenerUrlImagen(this.dispositivo.media)
      }
      if (this.dispositivo.imagen) {
        return this.getImagenPorDefecto(this.dispositivo.imagen)
      }
      return this.getImagePlaceholder()
    },

    getImagenPorDefecto(nombreImagen) {
      const imagenesDefecto = {
        'ImagenDefault': '/img/dispositivos/default.png',
        '1erEquipoHVAC': '/img/dispositivos/hvac1.png',
        '2doEquipoHVAC': '/img/dispositivos/hvac2.png',
        'ImagenColectorDePolvo': '/img/dispositivos/colector.png',
        'ImagenEquipoDeAireAcondicionadoIndustrial': '/img/dispositivos/industrial.png'
      }
      return imagenesDefecto[nombreImagen] || this.getImagePlaceholder()
    },

    getImagePlaceholder() {
      return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200"%3E%3Crect fill="%23e5e7eb" width="200" height="200"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" font-family="Arial, sans-serif" font-size="14" fill="%239ca3af"%3ESin imagen%3C/text%3E%3C/svg%3E'
    },

    handleImageError(event) {
      console.warn('⚠️ Error cargando imagen del dispositivo:', this.dispositivo.nombre_dispositivo)
      this.imageError = true
      event.target.src = this.getImagePlaceholder()
    },

    iniciarEdicionImagen() {
      if (this.$refs.inputImagen) {
        this.$refs.inputImagen.click();
      }
    },

    async manejarSeleccionImagen(event) {
      const archivo = event.target.files?.[0];
      if (!archivo) {
        console.log('❌ No se seleccionó archivo');
        return;
      }
      console.log('📁 Archivo seleccionado:', {
        nombre: archivo.name,
        tipo: archivo.type,
        tamaño: `${(archivo.size / 1024 / 1024).toFixed(2)} MB`
      });
      const tiposPermitidos = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      if (!tiposPermitidos.includes(archivo.type)) {
        this.$emit('mostrar-error', 'Formato de imagen no soportado. Use JPG, PNG o GIF');
        this.resetearInputImagen();
        return;
      }
      const maxSize = 5 * 1024 * 1024;
      if (archivo.size > maxSize) {
        this.$emit('mostrar-error', 'La imagen es muy grande. El tamaño máximo es 5MB');
        this.resetearInputImagen();
        return;
      }
      this.crearPrevisualizacionImagen(archivo);
      this.archivoImagenSeleccionado = archivo;
      await this.confirmarYSubirImagen();
    },

    crearPrevisualizacionImagen(archivo) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previsualizacionImagen = e.target.result;
        console.log('✅ Previsualización creada');
      };
      reader.onerror = () => {
        console.error('❌ Error creando previsualización');
        this.$emit('mostrar-error', 'Error al cargar la imagen');
      };
      reader.readAsDataURL(archivo);
    },

    async confirmarYSubirImagen() {
      const confirmar = confirm('¿Desea cambiar la imagen del dispositivo?');
      if (!confirmar) {
        this.resetearInputImagen();
        return;
      }
      await this.subirImagenDispositivo();
    },

    async subirImagenDispositivo() {
      if (!this.archivoImagenSeleccionado) {
        console.error('❌ No hay archivo para subir');
        return;
      }
      this.subiendoImagen = true;
      try {
        console.log('⬆️ Subiendo imagen del dispositivo...');
        this.$emit('imagen-actualizada', this.archivoImagenSeleccionado);
        console.log('✅ Solicitud de actualización de imagen enviada');
      } catch (error) {
        console.error('❌ Error subiendo imagen:', error);
        this.$emit('mostrar-error', 'Error al actualizar la imagen');
      } finally {
        this.subiendoImagen = false;
        this.resetearInputImagen();
      }
    },

    resetearInputImagen() {
      if (this.$refs.inputImagen) {
        this.$refs.inputImagen.value = '';
      }
      this.archivoImagenSeleccionado = null;
      this.previsualizacionImagen = null;
    },

    async eliminarImagenDispositivo() {
      const confirmar = confirm('¿Desea eliminar la imagen actual del dispositivo?');
      if (!confirmar) return;
      try {
        console.log('🗑️ Eliminando imagen del dispositivo...');
        this.$emit('imagen-eliminada');
        console.log('✅ Solicitud de eliminación enviada');
      } catch (error) {
        console.error('❌ Error eliminando imagen:', error);
        this.$emit('mostrar-error', 'Error al eliminar la imagen');
      }
    }
  }
}
</script>

<style scoped>
.modal-open {
  overflow: hidden;
}

.rotate-180 {
  transform: rotate(180deg);
}
</style>